import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business ダッシュボードの品質KPI指標を取得する画面用フック
 * @graph-connects dashboardApi [calls] ダッシュボードAPIクライアント呼び出し
 * @graph-connects queryKeys [calls] クエリキー生成
 */
export function useKpi(date?: string) {
  return useQuery({
    queryKey: queryKeys.dashboard.kpi(date),
    queryFn: () => dashboardApi.getKpi(date),
  });
}

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business KPI指標の時系列トレンドを取得する画面用フック
 * @graph-connects dashboardApi [calls] ダッシュボードAPIクライアント呼び出し
 * @graph-connects queryKeys [calls] クエリキー生成
 */
export function useKpiTrend(days = 730) {
  return useQuery({
    queryKey: queryKeys.dashboard.kpiTrend(days),
    queryFn: () => dashboardApi.getKpiTrend(days),
  });
}

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business ダッシュボードの品質概況サマリを取得する画面用フック
 * @graph-connects dashboardApi [calls] ダッシュボードAPIクライアント呼び出し
 * @graph-connects queryKeys [calls] クエリキー生成
 */
export function useSummary(date?: string) {
  return useQuery({
    queryKey: queryKeys.dashboard.summary(date),
    queryFn: () => dashboardApi.getSummary(date),
  });
}
